import { toast } from "react-toastify";
import { useCurrentUser, useLogout } from "utils/hooks";

const useFetchPracticeById = () => {
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const fetchPracticeById = async (practiceId: string) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            query {
              getPracticeById(practiceId: "${practiceId}") {
                uuid
                createdAt
                updatedAt
                practiceName
                treatmentType
                practiceSize
                address1
                address2
                state
                zipcode
                phone
                slug
                organizationId
                status
                logoId
              }
            }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_practice_information",
        },
      });

      const resData = await res.json();

      if (res.ok) {
        return resData.data.getPracticeById;
      }

      if (!res.ok) {
        if (resData.errors[0].message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else {
          toast.error(
            `Hmm, something went wrong. ${resData.errors[0].message}`
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return {
    fetchPracticeById,
  };
};

export default useFetchPracticeById;
